export default "__VITE_ASSET__COpmrTsX__"